import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';

import { ButtonComponent } from './button.component';
import { LoadingSvgComponent } from './svg/loading/loading-svg.component';
import { ArrowSvgComponent } from './svg/arrow/arrow-svg.component';
import { AddSvgComponent } from './svg/add/add-svg.component';
import { XSvgComponent } from './svg/x/x-svg.component';
import { RemoveSvgComponent } from './svg/remove/remove-svg.component';
import { RefreshSvgComponent } from './svg/refresh/refresh-svg.component';
import { InfoSvgComponent } from './svg/info/info.component';

@NgModule({
  declarations: [
    ButtonComponent,
    LoadingSvgComponent,
    ArrowSvgComponent,
    AddSvgComponent,
    XSvgComponent,
    RemoveSvgComponent,
    RefreshSvgComponent,
    InfoSvgComponent
  ],
  imports: [CommonModule, MatTooltipModule],
  exports: [ButtonComponent]
})
export class ButtonModule {}
